module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/hamburger_gray-0fe996a06d0a2233ee26caca3d883d95.svg";